import { createFileRoute } from "@tanstack/react-router";
import { GeneralSettingsPage } from "@/features/tenant-settings/pages/general-settings-page";

export const Route = createFileRoute("/_authed/tenants/$slug/settings/")({
  component: GeneralSettingsPage,
});
